import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrompthubNav, MyPrompts } from '../components';
import { AI_SETTINGS_SYSTEM_PROMPT_PREFILL_KEY } from '../utils/systemPromptCategory';
import { PageShell } from 'components/AppShell';
import { USE_NEW_SHELL } from 'core/flags';
import styles from './PrompthubPage.module.scss';

export default function MyPromptsPage() {
  const navigate = useNavigate();

  const handleUsePrompt = useCallback(
    (content: string) => {
      try {
        localStorage.setItem('chat_message_text', content);
        navigate('/chat');
      } catch {
        navigate('/chat');
      }
    },
    [navigate]
  );

  const handleApplyToAiSettings = useCallback(
    (content: string) => {
      try {
        localStorage.setItem(AI_SETTINGS_SYSTEM_PROMPT_PREFILL_KEY, JSON.stringify(content));
      } catch {
        // ignore
      }
      navigate('/ai-settings');
    },
    [navigate]
  );

  const body = (
    <MyPrompts onUsePrompt={handleUsePrompt} onApplyToAiSettings={handleApplyToAiSettings} />
  );

  if (USE_NEW_SHELL) {
    return (
      <PageShell
        title="Мои промпты"
        subtitle="Сохранённые шаблоны для быстрого использования в чате"
        toolbar={<PrompthubNav />}
      >
        {body}
      </PageShell>
    );
  }

  return (
    <div className={styles.root}>
      <PrompthubNav />
      {body}
    </div>
  );
}
